export enum InputDateTimeReactMode {
  idrmDate = 1,
  idrmTime = 2,
  idrmDateTime = 3
}
